import React, { useState, useEffect } from 'react';
import { getProducts } from '../api';
import ProductCard from '../components/ProductCard';

function Home() {
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [loading, setLoading] = useState(true);

  const categories = [
    { value: '', label: 'Все букеты' },
    { value: 'roses', label: '🌹 Розы' },
    { value: 'peonies', label: '🌸 Пионы' },
    { value: 'tulips', label: '🌷 Тюльпаны' },
    { value: 'bouquets', label: '💐 Авторские букеты' }
  ];

  useEffect(() => {
    loadProducts();
  }, [selectedCategory]);

  const loadProducts = async () => {
    setLoading(true);
    const data = await getProducts(selectedCategory || null);
    setProducts(data);
    setLoading(false);
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>🌿 ROOTS</h1>
          <p className="hero-subtitle">Авторские букеты с доставкой</p>
          <p className="hero-regions">Крым • ЛНР • ДНР • Херсон • Запорожье</p>
          <div className="hero-buttons">
            <a href="#catalog" className="hero-button">Выбрать букет</a>
            <a
              href="https://t.me/roots_flower"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-button secondary"
            >
              ✈️ Связь с нами
            </a>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="advantages">
        <div className="advantages-container">
          <div className="advantage-item">
            <div className="advantage-icon">✓</div>
            <h3>Гарантия свежести</h3>
            <p>Цветы сохраняют свежесть не менее 1.5 недель</p>
          </div>
          <div className="advantage-item">
            <div className="advantage-icon">🚀</div>
            <h3>Доставка за 3 часа</h3>
            <p>Быстрая доставка по всем регионам</p>
          </div>
          <div className="advantage-item">
            <div className="advantage-icon">💐</div>
            <h3>Авторские букеты</h3>
            <p>Профессиональные флористы с опытом</p>
          </div>
        </div>
      </section>

      {/* Catalog */}
      <section id="catalog" className="catalog">
        <h2 className="catalog-title">Каталог букетов</h2>
        
        <div className="category-filters">
          {categories.map(cat => (
            <button
              key={cat.value}
              className={`category-button ${selectedCategory === cat.value ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.value)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="loading">Загрузка...</div>
        ) : (
          <div className="products-grid">
            {products.map(product => (
              <ProductCard
                key={product.id}
                product={product}
              />
            ))}
          </div>
        )}

        {!loading && products.length === 0 && (
          <div className="no-products">Букеты не найдены</div>
        )}
      </section>
    </div>
  );
}

export default Home;
